import type { SeaAreaId } from '../voyage/regions';

/** A fixed physical island. Eligibility is deliberate; absence never grants permission. */
export interface SceneryPlacement {
  readonly id: string;
  readonly label: string;
  readonly sprite: string;
  readonly area: SeaAreaId;
  /** Sprite-anchor position in leagues, not a seed/camera-relative offset. */
  readonly x: number;
  readonly y: number;
  readonly rationale: string;
  readonly authority: string;
}

/**
 * Only the two retained round-6 low skerries are currently eligible. Blackstage and
 * Standings were declined for their shapes; unused harbour art is not scenery by default.
 * These placements are an engineering correction, not a claim that the sea has enough art.
 * The existing authority rows retain these exact assets; no new visual approval is asserted.
 */
export const SCENERY_CATALOGUE: readonly SceneryPlacement[] = [
  {
    id: 'field:weirarm', label: 'Weirarm', sprite: 'weirarm-7470', area: 'wrack', x: 55, y: -5,
    rationale: 'One low fishing weir outside the first outward Wrack turn, before Tangsay. Its fixed position frames that passage without occupying Murrin water or the track.',
    authority: 'gauntlet/assets.manifest.json: weirarm-7470; retained round-6 field scenery; gauntlet/island/r6/fleet.json',
  },
  {
    id: 'field:tarholm', label: 'Tarholm', sprite: 'tarholm-7451', area: 'rime', x: 40, y: 490,
    rationale: 'One low tar-working skerry northwest of Torsk Vard, moved deliberately from(60,470) to(40,490) after the225m Torsk body was drawn. It clears the northern coil and the full harbour body, and remains a separate working shore rather than a substitute Torsk harbour.',
    authority: 'gauntlet/assets.manifest.json: tarholm-7451; retained round-6 field scenery; gauntlet/island/r6/fleet.json',
  },
];
